import axios from 'axios';

import { BASE_API_URL, processAPIWithHeaders } from '@/utils/helpers.js';

import { useConfigStore } from '@/store';

// for headers
const header = (type, auth) => {
    if (type === 'POST') {
        return { 'Content-Type': 'application/json', Authorization: auth };
    }
    return { Authorization: auth };
};

// user registration
export const userRegistration = async (body, headerBody) => {
    const { auth } = headerBody;
    try {
        const response = await processAPIWithHeaders('secure/users', 'POST', {
            body: body,
            headers: header('POST', auth),
        });
        return response;
    } catch (error) {
        console.debug('error in registration service userRegistration', error);
        return new Error(error.message);
    }
};

// user account registration
export const getUserAccount = async (headerBody) => {
    const { auth, username } = headerBody;
    try {
        const response = await processAPIWithHeaders(`secure/user/accounts/${username}`, 'GET', {
            headers: header('GET', auth),
        });
        return response;
    } catch (error) {
        console.debug('error in registration service get user account', error);
        return new Error(error.message);
    }
};

// add/update user account
export const addUserAccounts = async (body, headerBody) => {
    const { auth, username } = headerBody;

    try {
        const response = await processAPIWithHeaders(`secure/user/accounts/${username}`, 'POST', {
            body: body,
            headers: header('POST', auth),
        });
        return response;
    } catch (error) {
        console.debug('error in registration service add user account', error);
        return new Error(error.message);
    }
};

export const fetchPatientDataByRegistrationCode = async (code) => {
    try {
        const customer = useConfigStore.getState().currentCustomer;
        const customer_id = customer?.customer_id?.[0].text;

        const response = await axios.get(`${BASE_API_URL}/public/users/registration-code`, {
            params: { code },
            headers: { customer_id },
        });

        return { success: !!response.data?.data, data: response.data?.data };
    } catch (error) {
        const status = error.response?.status;
        return {
            success: false,
            error: error.message || 'Failed to fetch patient data',
            status,
            isExpiredOrInvalid: status === 404 || status === 410,
        };
    }
};
